import { render, staticRenderFns } from "./AskAQuestionForm.vue?vue&type=template&id=a2b5eac4&"
import script from "./AskAQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AskAQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports